<div class="rememberDeviceContainer" *ngIf="globalService.isRememberDeviceEnabled()">
  <label class="checkbox-label row mt-1 mb-4" for="rememberDevice" (mousedown)="handleMouseDown($event)">
    <mat-checkbox class="rememberThisDeviceCheckbox" disableRipple value="false"[checked]="false" id="rememberDevice" name="rememberDevice" [(ngModel)]="rdService.rememberDeviceChecked">
      Remember this device
      <img src="assets/img/help-icon.svg" title="You will not be prompted for multi-factor authentication again." alt="Remember this device"
          class="tooltip-icon" (click)="tooltipClick($event)" onkeypress=""/>
    </mat-checkbox>
  </label>
</div>